type ProblemDetails = {
  code?: string | null;
  detail?: string | null;
  status?: number | null;
};

type ApiErrorLike = {
  response?: {
    status?: number;
    data?: ProblemDetails | null;
  };
};

const RECURRENCE_ERROR_LABEL_KEYS: Record<string, string> = {
  RECURRENCE_NOT_FOUND: "recurrence.error.notFound",
  RECURRENCE_TRANSACTION_NOT_FOUND: "recurrence.error.transactionNotFound",
  TRANSACTION_NOT_FOUND: "recurrence.error.transactionNotFound",
  MARKETPLACE_RECURRENCE_NOT_EDITABLE: "recurrence.error.marketplace",
  TARGET_TRANSACTION_ID_REQUIRED: "recurrence.error.targetRequired",
  INSUFFICIENT_ROLE: "recurrence.error.insufficientRole",
};

const TRANSACTION_SAVE_ERROR_LABEL_KEYS: Record<string, string> = {
  RECURRENCE_LIMIT_EXCEEDED: "recurrence.error.limitExceeded",
  INVALID_RECURRENCE_PERIOD: "recurrence.error.invalidPeriod",
  RECURRENCE_NOT_ALLOWED: "recurrence.error.notAllowed",
};

export const getApiErrorCode = (error: unknown): string | null => {
  const code = (error as ApiErrorLike)?.response?.data?.code;
  return typeof code === "string" && code.length > 0 ? code : null;
};

export const getApiErrorStatus = (error: unknown): number | null => (error as ApiErrorLike)?.response?.status ?? null;

export const getTransactionSaveErrorLabelKey = (error: unknown, fallbackKey: string): string => {
  const code = getApiErrorCode(error);

  return (code && TRANSACTION_SAVE_ERROR_LABEL_KEYS[code]) || fallbackKey;
};

export const getRecurrenceErrorLabelKey = (error: unknown, fallbackKey: string): string => {
  const code = getApiErrorCode(error);
  if (code && RECURRENCE_ERROR_LABEL_KEYS[code]) return RECURRENCE_ERROR_LABEL_KEYS[code];

  return getApiErrorStatus(error) === 403 ? RECURRENCE_ERROR_LABEL_KEYS.INSUFFICIENT_ROLE : fallbackKey;
};
